import { render, staticRenderFns } from "./btn_tree.vue?vue&type=template&id=13864b84&"
import script from "./btn_tree.vue?vue&type=script&lang=js&"
export * from "./btn_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports